import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import ForgotPin from '../sharedComponents/resendPin';
import { setErrorPanel } from '../../../redux/utilities/utils.actions';
import Loader from '../../../utils/Loader';
import FootNote from '../sharedComponents/footNote';
import LoginForm from '../sharedComponents/loginForm';
import '../userAuthenticationStyles.css';
import SignInButton from '../sharedComponents/signInButton';
import {
	changeLoginId,
	setUserType,
} from '../../../redux/userAuthentication/userAuth.actions';
import UserTypes from '../../../utils/userTypes';
const mapStateToProps = (state) => {
	const { loginDetails, utils } = state.rootReducer;
	return {
		loginId: loginDetails.loginId,
		userType: loginDetails.userType,
		error: utils.errorPanel,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setErrorPanel: (value) => dispatch(setErrorPanel(value)),
		changeLoginId: (value) => dispatch(changeLoginId(value)),
		setUserType: (type) => dispatch(setUserType(type)),
	};
};

class VerifyAccount extends Component {
	constructor(props) {
		super(props);
		Loader.hide();
	}

	componentDidMount() {
		const { changeLoginId, setErrorPanel, userType, setUserType } = this.props;

		let errorPanel = {
			panelClass: 'alert alert-success',
			panelMsg: 'PIN sent to phone/email. Enter PIN to get started.',
		};
		setErrorPanel(errorPanel);
		if (!!localStorage.getItem('login_id')) {
			changeLoginId(localStorage.getItem('login_id'));
		}

		if (userType !== UserTypes.Junior) {
			setUserType(UserTypes.Junior);
		}
	}

	render() {
		const {
			error: { panelClass, panelMsg },
		} = this.props;
		return (
			<div id="wrapper">
				<div className="col-lg-12 col-md-12 col-sm-12 login-pg-container">
					<div className="col-lg-12 col-md-12 col-sm-12 login-wrapper-container">
						<form action="" className="form-horizontal step-login-form" method="">
							<div className="col-lg-offset-4 col-md-offset-4 col-lg-4 col-md-4 col-sm-12 login-box">
								<div className="message_box">
									<div className={panelClass}>{panelMsg}</div>
								</div>
								<LoginForm
									headerText="Log in with"
									nameInfoText="*Please ensure if the above email/phone number is correct"
								/>
								<div className="pinResetBlock">
									<ForgotPin resendPinText="Click here to resend PIN!" />
								</div>
								<br />
								<SignInButton signInText="VERIFY NOW" />
								<hr />
								<FootNote userActivity="Verify Now" />
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(
	compose(connect(mapStateToProps, mapDispatchToProps))(VerifyAccount),
);
